const REGEX = {
  EMAIL: /^[\w-+.]+@[\w-.]+\.[A-Za-z]+$/,
  PASSWORD:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()\-_=+[\]{}|;:,.<>/?]).{8,255}$/,
  SERIAL: /^[A-Z0-9]{8,9}$/,
  CODE: /^[A-Z]{4}$/,
  NAME: /^.{1,35}$/,
  COMPANY: /^.{1,80}$/,
  ADDRESS: /^.{0,40}$/,
  PHONE: /^.{0,32}$/,
  DEALER: /^.{1,80}$/,
} as const;

export default REGEX;
